<template>
  <div>
    <div class="search">
      <el-form label-width="80px" size="small">
        <el-row :gutter="20">
          <el-col span="5">
            <el-form-item label="项目名称">
              <el-select
                v-model="projectId"
                placeholder="请选择"
                @change="generateCharts"
              >
                <el-option
                  v-for="(item, index) in projectList"
                  :key="index"
                  :label="item.name"
                  :value="item.id"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col span="5" v-if="show">
            <el-form-item label="科室">
              <el-cascader
                v-model="value"
                :options="options"
                :props="props"
                placeholder="请选择"
                @change="generateCharts"
              ></el-cascader>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
    </div>
    <div class="page">
      <div class="grid"><div id="devices" class="echarts"></div></div>
      <div class="grid"><div id="inspection" class="echarts"></div></div>
      <div class="grid"><div id="repair" class="echarts"></div></div>
      <div class="grid"><div id="upkeep" class="echarts"></div></div>
    </div>
  </div>
</template>

<script>
import {
  getValueAnalysis,
  getCostEvaluation,
  getCreateIncome,
  getSatisfaction,
} from "@/api/crmedical/statistics/index";
import dayjs from "dayjs";
import { opt_inspection, opt_devices, opt_repair, opt_upkeep } from "./options";
import { getProjectList } from "@/api/crmedical/project/project";
import {
  getProjectDept,
  getProjectDeptTopLevel,
  getDeviceNum,
  getInspectNum,
  getRepairCost,
  getUpkeepCost,
} from "@/api/crmedical/device/charts";
export default {
  computed: {
    projectId() {
      return this.projectId;
    },
  },
  data() {
    return {
      projectId: "",
      projectList: [],
      //科室cascader
      options: null,
      //科室cascader值:array
      value: null,
      //科室cascader
      props: {
        label: "title",
        lazy: true,
      },
      show: false,
    };
  },
  created() {},
  async mounted() {
    let res = await getProjectList();
    this.projectList = res.data;
    this.projectId = res.data[0].id; //默认取第一个
    this.props = Object.assign({}, this.props, {
      lazyLoad: (node, resolve) => {
        const parentId = node.value || 0;
        const params = { parentId, projectId: this.projectId };
        if (parentId == 0) {
          getProjectDeptTopLevel(params).then((res) => {
            //hasChildren ==> leaf
            res.data.forEach((item) => {
              item.leaf = !item.hasChildren;
            });
            resolve(res.data);
          });
        } else {
          getProjectDept(params).then((res) => {
            //hasChildren ==> leaf
            res.data.forEach((item) => {
              item.leaf = !item.hasChildren;
            });
            resolve(res.data);
          });
        }
      },
    });
      this.show = true;
    this.generateCharts();
  },
  methods: {
    async generateCharts() {
      console.log('generateCharts==>','start');
      let params = { projectId: this.projectId };
      if (this.value) {
        //科室
        params.deptId = this.value[this.value.length];
      }
      //1.设备分类统计
      const devideRes = await getDeviceNum(params);
      //1.1处理seriesData
      let deviceSeriesData = [];
      devideRes.data.forEach((element) => {
        deviceSeriesData.push({
          name: element.typeName,
          value: element.num,
        });
      });
      //1.2修改配置
      opt_devices.series[0].data = deviceSeriesData;
      //1.3渲染
      echarts.init(document.getElementById("devices")).setOption(opt_devices);
      //2.巡检统计
      const inspectionRes = await getInspectNum(params);
      //2.1处理seriesData和xAxis
      let inspectionSeries_normal = {
        name: "正常",
        type: "bar",
        stack: "全部",
        data: [],
      };
      let inspectionSeries_error = {
        name: "异常",
        type: "bar",
        stack: "全部",
        data: [],
      };
      let xAxis = [
        {
          type: "category",
          axisTick: { show: false },
          data: [],
        },
      ];
      inspectionRes.data.forEach((element) => {
        inspectionSeries_normal.data.push(element.count);
        inspectionSeries_error.data.push(element.errorCount);
        //2020-11-20 ==> 11/20
        let temp = dayjs(element.date).format("MM/DD");
        xAxis[0].data.unshift(temp);
      });
      //2.2修改配置
      opt_inspection.xAxis = xAxis;
      opt_inspection.series[0] = inspectionSeries_normal;
      opt_inspection.series[1] = inspectionSeries_error;
      //2.3渲染
      echarts
        .init(document.getElementById("inspection"))
        .setOption(opt_inspection);
      //3.维修成本统计
      const repairCostRes = await getRepairCost(params);
      //3.1处理seriesData和xAxis
      let repairCostxAxis = null,
        repairCostSerise = [];
      if (repairCostRes.data.length > 0) {
        //处理xAxis
        let dateTemp = [];
        Object.keys(repairCostRes.data[0].typeCostMap).forEach((element) => {
          dateTemp.push(dayjs(element).format("MM/DD"));
        });
        repairCostxAxis = {
          type: "category",
          axisTick: { show: false },
          data: dateTemp,
        };
        //处理seriesData
        repairCostRes.data.forEach((element) => {
          repairCostSerise.push({
            type: "line",
            data: Object.values(element.typeCostMap),
            name: element.typeName,
          });
        });
        //3.2更改配置
        opt_repair.series = repairCostSerise;
        opt_repair.xAxis = repairCostxAxis;
        echarts.init(document.getElementById("repair")).setOption(opt_repair);
      }
      //3.3渲染
      //4维保成本统计
      const upkeepCostRes = await getUpkeepCost(params);
      let upkeepCostXAxis = {
          type: "category",
          axisTick: { show: false },
          data: [],
        },
        upkeepCostSeriesData = [];
      upkeepCostRes.data.forEach((element) => {
        let temp = dayjs(element.date).format("MM/DD");
        upkeepCostXAxis.data.unshift(temp);
        upkeepCostSeriesData.push(element.cost);
      });
      opt_upkeep.xAxis = upkeepCostXAxis;
      opt_upkeep.series[0].data = upkeepCostSeriesData;
      echarts.init(document.getElementById("upkeep")).setOption(opt_upkeep);
    },
  },
};
</script>

<style lang="scss" scoped>
.page {
  display: flex;
  justify-content: space-between;
  align-content: flex-start;
  flex-wrap: wrap;
}

.grid {
  width: 50%;
  border: 1px solid #000;
  padding: 20px;
}
.grid-flex {
  display: flex;
  justify-content: flex-start;
  align-items: center;
}
.echarts {
  width: 600px;
  height: 330px;
}
.echarts-half {
  width: 350px;
  margin-right: 100px;
}
</style>
